import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e: any, fallback = "Something went wrong") =>
  e?.response?.data?.detail || e?.message || fallback;
